// @ts-strict-ignore
import { ArticleVO } from './article.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ExportToolArticleVO')
export class ExportToolArticleVO extends ArticleVO {

  public static readonly CLASS_NAME: string = 'ExportToolArticleVO';

  @JsonProperty('oldArticleId', 'Number')
  public oldArticleId: number = undefined;

  @JsonProperty('minimumStockLevel', 'Number')
  public minimumStockLevel: number = undefined;

  @JsonProperty('isFullArticle', 'Boolean')
  public isFullArticle: boolean = undefined;

  public constructor() {
    super();
    this.classType = ExportToolArticleVO.CLASS_NAME;
  }
}
